module.exports = __webpack_public_path__ + "static/img/h3.d5a9e61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/h3.jpg
// module id = 204S
// module chunks = 0